import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function EmailLog() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    axios.get('/api/emails/log', { params: { page, limit: 25 } })
      .then(r => { setLogs(r.data.logs); setTotal(r.data.total); }).catch(() => {});
  }, [page]);

  return (
    <div>
      <div style={{ marginBottom:'20px' }}>
        <h1 style={{ fontSize:'22px', fontWeight:700, letterSpacing:'-0.03em' }}>Ιστορικό Αποστολών</h1>
        <p style={{ color:'var(--slate)', fontSize:'12px', marginTop:'3px' }}>{total} αποστολές συνολικά</p>
      </div>
      <div className="tbl-wrap">
        <table>
          <thead><tr><th>Θέμα</th><th>Αποστολέας</th><th style={{ textAlign:'right' }}>Παραλήπτες</th><th>Κατάσταση</th><th className="hide-mobile">Αποστολέας Χρήστης</th><th>Ημερομηνία</th></tr></thead>
          <tbody>
            {logs.map(l => (
              <tr key={l.id}>
                <td style={{ fontWeight:500, maxWidth:'260px' }} className="truncate">{l.subject}</td>
                <td style={{ fontSize:'12px', color:'var(--slate)' }}>{l.sender_email}</td>
                <td style={{ textAlign:'right', fontWeight:600, fontFamily:'Inter, sans-serif' }}>{l.recipients_count?.toLocaleString()}</td>
                <td><span className={`badge ${l.status==='sent'?'badge-green':l.status==='failed'?'badge-red':'badge-amber'}`}>
                  {l.status==='sent'?'Επιτυχία':l.status==='failed'?'Αποτυχία':'Μερική'}
                </span></td>
                <td className="hide-mobile" style={{ color:'var(--slate)', fontSize:'12px' }}>{l.sent_by_name||'—'}</td>
                <td style={{ color:'var(--slate)', fontSize:'12px', whiteSpace:'nowrap' }}>{new Date(l.created_at).toLocaleString('el-GR',{day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'})}</td>
              </tr>
            ))}
            {logs.length===0 && <tr><td colSpan={6} style={{ textAlign:'center', padding:'48px', color:'var(--mist)' }}>Δεν υπάρχουν αποστολές ακόμα</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
